<template>
  <transition name="slideDown">
    <modal title="Add Category" v-if="show">
      <div class="form-horizontal">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <label for="name"
                class="col-sm-2 control-label">
                Name
              </label>

              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  placeholder="Name"
                  v-model="optionForm.categories.name">
              </div>
            </div>

            <div class="form-group">
              <label for="name_en"
                class="col-sm-2 control-label">
                Name En
              </label>

              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  id="name_en"
                  placeholder="Name English"
                  v-model="optionForm.categories.name_en">
              </div>
            </div>

            <div class="form-group">
              <label for="slug"
                class="col-sm-2 control-label">
                Slug
              </label>

              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  id="slug"
                  placeholder="Slug"
                  v-model="optionForm.categories.slug">
              </div>
            </div>

            <div class="form-group">
              <label for="parent"
                class="col-sm-2 control-label">
                Image
              </label>

              <div class="col-sm-10">
                <FileGallery
                  type="category"
                  :inline="true"
                  @update-images="setImage"
                  :selected="optionForm.categories.image" />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 text-right">
            <button class="btn btn-primary"
              @click="$emit('add')">
              Add
            </button>
          </div>
        </div>
      </div>
    </modal>
  </transition>
</template>

<script>
import FileGallery from '@/components/modules/common/FileGallery';
import Modal from '@/components/modules/common/Modal';

export default {
  props: {
    optionForm: {
      type: Object,
      required: true,
    },

    show: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  components: {
    FileGallery,
    Modal,
  },

  methods: {
    setImage(payload) {
      this.$emit('setImage', payload);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/products/partials/ModalCategories.vue